import { TAvailableFilter } from 'components/Base/FilterComponents/FilterComponents.type';

export type TFiltersProps = {
  filtersShow: boolean;
  filterList: TAvailableFilter<EAnimalsFilters, EAnimalsFiltersName>[];
  onFiltersSelected: (
    filter: EAnimalsFilters,
  ) => (ids: string | string[]) => void;
  onFilterShow: (filter: EAnimalsFilters) => void;
  selectedFilterValues: {
    [key in EAnimalsFilters]?: string[];
  };
  path: string;
  onClearAllSelectedFilters: () => void;
  selectedFiltersCount: number;
  onShowFilter?: (show: boolean) => void;
};

export type TTableProps = {
  filters: { [key: string]: string[] };
  filtersShow: boolean;
};

export enum EAnimalsFilters {
  TYPE = 'types',
  PROPERTY_MANAGEMENT = 'propertyManagementIds',
  PROPERTY = 'propertyIds',
  ANIMAL_NAME = 'animalNameSearch',
  TENANT_NAME = 'tenantSearch',
  VERIFICATION_STATUS = 'animalStatuses',
  // Legacy key: no longer offered in the UI, kept so stored references stay typed.
  RESIDENCY_STATUS = 'animalResidencyStates',
  APPLICATION_STATUS = 'applicationStatuses',
  RESIDENCY_TAG = 'residencyTags',
  SPECIES = 'species',
  UNIT_NUMBER = 'unitNumber',
  PAYMENT_STATUS = 'paymentStatuses',
}

export enum EAnimalsFiltersName {
  TYPE = 'Type',
  PROPERTY_MANAGEMENT = 'Property management',
  ANIMAL_NAME = 'Animal name',
  TENANT_NAME = 'Owner name',
  PROPERTY = 'Property',
  VERIFICATION_STATUS = 'Verification status',
  APPLICATION_STATUS = 'Application status',
  RESIDENCY_TAG = 'Residency tag',
  SPECIES = 'Species',
  UNIT_NUMBER = 'Unit #',
  PAYMENT_STATUS = 'Payment status',
}
